import Header from "@/layouts/Header";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import { loadPermissionById } from "../redux/rtk/features/auth/authSlice";
import { cn } from "../utils/functions";
import Footer from "./Footer";
import SideNav from "./SideNav/SideNav";
import { useLanguage } from "@/contexts/LanguageContext";
import ChatDrawer from "../components/Chat/ChatDrawer";

const roleId = localStorage.getItem("roleId");
const mode = import.meta.env.VITE_APP_VERSION;

function AdminLayout() {
  const dispatch = useDispatch();
  const { isRTL } = useLanguage();
  const [collapsed, setCollapsed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [imageError, setImageError] = useState();
  const { data, loading } = useSelector((state) => state?.setting) || {};
  const {
    list: permissions,
    loading: permissionLoad,
    error,
  } = useSelector((state) => state.auth) || {};

  const handleCollapsed = (val) => {
    setCollapsed(val);
  };

  const openDrawer = () => setVisible(!visible);

  useEffect(() => {
    if (!permissions && !permissionLoad && !error) {
      dispatch(loadPermissionById(roleId));
    }
  }, [dispatch, error, permissionLoad, permissions]);

  return (
    <main
      className={cn("relative  w-full h-screen overflow-hidden flex flex-row", {
        "h-[calc(100vh-32px)] mt-8": mode === "demo",
      })}>
      <div
        className={cn(
          "hidden md:flex dark:bg-transparent bg-white dark:border-gray-50 border-2 text-gray-400 absolute w-[30px] h-[30px] leading-[30px] rounded-full justify-center items-center z-30 duration-300 top-[10px]",
          {
            // LTR positions
            "md:left-[185px] 2xl:left-[225px]": !collapsed && !isRTL,
            "left-[70px]": collapsed && !isRTL,
            // RTL positions
            "md:right-[185px] 2xl:right-[225px]": !collapsed && isRTL,
            "right-[70px]": collapsed && isRTL,
          }
        )}>
        {collapsed ? (
          // When collapsed: show arrow pointing in the direction to open
          // LTR: right arrow (→), RTL: left arrow (←)
          isRTL ? (
            <LeftOutlined
              onClick={() => handleCollapsed(!collapsed)}
              className="text-[16px] cursor-pointer"
            />
          ) : (
            <RightOutlined
              onClick={() => handleCollapsed(!collapsed)}
              className="text-[16px] cursor-pointer"
            />
          )
        ) : (
          // When open: show arrow pointing in the direction to close
          // LTR: left arrow (←), RTL: right arrow (→)
          isRTL ? (
            <RightOutlined
              onClick={() => handleCollapsed(!collapsed)}
              className="text-[16px] cursor-pointer"
            />
          ) : (
            <LeftOutlined
              onClick={() => handleCollapsed(!collapsed)}
              className="text-[16px] cursor-pointer"
            />
          )
        )}
      </div>
      {/* for small device */}
      {/* <Drawer
        title={false}
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        placement="left"
        width={240}>
        <div className="min-h-screen overflow-auto no-scrollbar w-[240px] bg-sideNavBg text-white select-none">
          {data && !loading && (
            <Link
              to={"/admin"}
              className="w-[180px] h-[70px] mx-auto flex items-center justify-center mt-3 mb-1 cursor-pointer">
              {data?.logo && !imageError ? (
                <img
                  className="text-white text-center"
                  alt="logo"
                  src={data.logo}
                  style={{ width: "180PX", height: "70px" }}
                  onError={() => setImageError(true)}
                />
              ) : (
                <h2 className="text-center flex items-center justify-center gap-2 text-[25px]">
                  {data?.companyName?.includes(" ") ? (
                    <>
                      <strong style={{ color: "#000", fontWeight: "semibold" }}>
                        {data?.companyName?.split(" ")[0]}
                      </strong>
                      <strong
                        style={{ color: "#3073f1", fontWeight: "semibold" }}>
                        {data?.companyName?.slice(
                          data?.companyName?.indexOf(" ") + 1
                        )}
                      </strong>
                    </>
                  ) : (
                    <strong style={{ color: "#3073f1", fontWeight: "bold" }}>
                      {data?.companyName}
                    </strong>
                  )}
                </h2>
              )}
            </Link>
          )}
          {loading && (
            <div className="w-[180px] h-[70px] mx-auto flex flex-col gap-1 mt-3 mb-1">
              <h1 className="bg-slate-50 opacity-10 h-4 rounded w-full animate-pulse"></h1>
              <h1 className="bg-slate-50 opacity-10 h-4 rounded w-full animate-pulse"></h1>
              <h1 className="bg-slate-50 opacity-10 h-4 rounded w-full animate-pulse"></h1>
            </div>
          )}
          <SideNav />
        </div>
      </Drawer> */}

      <Drawer
        title={false}
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        placement={isRTL ? "right" : "left"}
        width={240}>
        <div className="min-h-screen overflow-auto no-scrollbar w-[240px] bg-white text-slate-700 select-none">
          <Link
            to="/admin"
            className="sticky top-0 z-10 flex items-center gap-2 h-[56px] px-3 border-b mb-3 bg-white">
            {data?.logo && !imageError ? (
              <img
                src={data?.logo}
                alt="logo"
                className="h-8 w-auto object-contain"
                onError={() => setImageError(true)}
              />
            ) : data?.companyName ? (
              data.companyName.includes(" ") ? (
                <span className="text-xl font-semibold truncate">
                  <span className="text-gray-800">
                    {data.companyName.split(" ")[0]}
                  </span>{" "}
                  <span className="text-[#3073f1]">
                    {data.companyName.slice(data.companyName.indexOf(" ") + 1)}
                  </span>
                </span>
              ) : (
                <span className="text-xl font-semibold truncate bg-gradient-to-r from-[#3073f1] to-[#55F] bg-clip-text text-transparent">
                  {data.companyName}
                </span>
              )
            ) : (
              <span className="text-xl font-semibold truncate text-slate-900">
                Company
              </span>
            )}
          </Link>

          <div className="pt-2">
            <SideNav />
          </div>
        </div>
      </Drawer>

      {/* // for large device */}
      <div
        className={cn(
          "hidden shadow-md md:block top-0 z-10 duration-300 h-screen w-[200px] 2xl:w-[240px] bg-sideNavBg text-gray-400 text-[13px] select-none",
          {
            "w-[86px] 2xl:w-[86px]": collapsed,
            "left-0": !isRTL,
            "right-0": isRTL,
          }
        )}>
        {data && !loading && (
          <Link
            to={"/admin"}
            className={cn(
              "w-[180px] h-[70px] mx-auto flex items-center justify-center my-3 cursor-pointer",
              {
                visible: !collapsed,
                invisible: collapsed,
              }
            )}>
            {data?.logo && !imageError ? (
              <img
                className="max-h-[70px] w-auto object-contain"
                alt="logo"
                src={data.logo}
                onError={() => setImageError(true)}
              />
            ) : (
              <h2 className="text-center flex items-center justify-center gap-2 text-[25px]">
                {data?.companyName?.includes(" ") ? (
                  <>
                    <strong style={{ color: "#000", fontWeight: "semibold" }}>
                      {data?.companyName?.split(" ")[0]}
                    </strong>
                    <strong
                      style={{ color: "#3073f1", fontWeight: "semibold" }}>
                      {data?.companyName?.slice(
                        data?.companyName?.indexOf(" ") + 1
                      )}
                    </strong>
                  </>
                ) : (
                  <strong style={{ color: "#3073f1", fontWeight: "bold" }}>
                    {data?.companyName}
                  </strong>
                )}
              </h2>
            )}
          </Link>
        )}
        {loading && (
          <div
            className={`w-[180px] h-[70px] mx-auto flex flex-col gap-1 my-3 ${!collapsed ? "visible" : "invisible"
              }`}>
            <h1 className="bg-slate-50 opacity-10 h-4 rounded  w-full  animate-pulse"></h1>
            <h1 className="bg-slate-50 opacity-10 h-4 rounded w-full  animate-pulse"></h1>
            <h1 className="bg-slate-50 opacity-10 h-4 rounded  w-full animate-pulse"></h1>
          </div>
        )}

        <SideNav collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={cn(
          `flex flex-col w-full 2xl:w-[calc(100vw-240px)] md:w-[calc(100vw-200px)] duration-300`,
          {
            "md:w-[calc(100vw-86px)] 2xl:w-[calc(100vw-86px)]": collapsed,
          }
        )}>
        <Header onPress={openDrawer} data={data} loading={loading} />
        <div className="flex-1 p-4 min-h-0 overflow-auto bg-white">
          <Outlet />
          <Footer />
        </div>
        <ChatDrawer />
      </div>

    </main>
  );
}

export default AdminLayout;
